// extracted by mini-css-extract-plugin
module.exports = {"reasonInput":"reasonInput__m6JnU"};